// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * LCC API
 * API for the LCC backend
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ConfirmAlarmRequest
 */
export interface ConfirmAlarmRequest {
    /**
     * Human-readable comment recorded with the confirm event
     */
    comment?: string;
}

/**
 * Check if a given object implements the ConfirmAlarmRequest interface.
 */
export function instanceOfConfirmAlarmRequest(value: object): value is ConfirmAlarmRequest {
    return true;
}

export function ConfirmAlarmRequestFromJSON(json: any): ConfirmAlarmRequest {
    return ConfirmAlarmRequestFromJSONTyped(json, false);
}

export function ConfirmAlarmRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConfirmAlarmRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'comment': json['comment'] == null ? undefined : json['comment'],
    };
}

export function ConfirmAlarmRequestToJSON(json: any): ConfirmAlarmRequest {
    return ConfirmAlarmRequestToJSONTyped(json, false);
}

export function ConfirmAlarmRequestToJSONTyped(value?: ConfirmAlarmRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'comment': value['comment'],
    };
}

